import { render, staticRenderFns } from "./all-department-dialog.vue?vue&type=template&id=4e211216"
import script from "./all-department-dialog.vue?vue&type=script&lang=js"
export * from "./all-department-dialog.vue?vue&type=script&lang=js"
import style0 from "./all-department-dialog.vue?vue&type=style&index=0&id=4e211216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports